import { useCallback, useContext } from 'react'

import { FrameBuilderStringsContext } from '@frame-builder/contexts/strings-context'
import { type StepDefinitionProps } from '@frame-builder/lib/steps'

import Button from '@frame-builder/components/utility/button'
import ListContainer from '@frame-builder/components/utility/list-container'
import ConfigurationDefinition from '../configuration-definition'
import SpacerSizeList from './spacer-size-list'

const SpacerDefinition = ({
  stepNumber,
  onClose,
  className,
}: StepDefinitionProps) => {
  const frameBuilderStrings = useContext(FrameBuilderStringsContext)

  const handleOkClick = useCallback(() => {
    onClose()
  }, [onClose])

  return (
    <ConfigurationDefinition
      stepNumber={stepNumber}
      title={frameBuilderStrings.spacerStepTitle}
      footerContent={frameBuilderStrings.spacerStepFooter}
      onClose={onClose}
      className={className}
    >
      <div className="flex flex-col px-5 space-y-5">
        <ListContainer gapSize="sm">
          <SpacerSizeList />
        </ListContainer>

        <div>
          <Button
            size="small"
            onClick={handleOkClick}
            className="min-w-32 grow-0 shrink-0"
          >
            {frameBuilderStrings.controlOkLabel}
          </Button>
        </div>
      </div>
    </ConfigurationDefinition>
  )
}

export default SpacerDefinition
